<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="container-fluid h-100p overflow-y-scroll vehicle-search-main px-2 px-sm-3 px-lg-4 m-2">
        <div class="top-section py-2 py-md-3">
            <div class="vehicle-page-header">
                <div class="vehicle-page-title-wrap">
                    <h3 class="vehicle-page-title">Vehicle Search</h3>
                    <p class="vehicle-page-subtitle">
                        Lookup vehicle details with registration, compliance and linked metadata.
                    </p>
                </div>

                <div class="credits-display">
                    <div class="credits-inline">
                        <span class="credits-inline-label">Remaining:</span>
                        <span class="credits-inline-value"><i class="fas fa-spinner fa-spin" *ngIf="creditsLoading" aria-hidden="true"></i><ng-container *ngIf="!creditsLoading">{{ availableCredits | creditsLabel }}</ng-container></span>
                    </div>
                    <button class="buy-credits-btn" (click)="onBuyCreditsButtonClick()">
                        <i class="fas fa-coins credits-icon"></i>
                        Buy Credits
                    </button>
                </div>
            </div>

            <div class="row align-items-center g-3 mx-0 vehicle-search-hero-row">
                <!-- Service Disabled Warning -->
                <div class="search-card-container py-3" *ngIf="isServiceDisabled">
                    <div class="service-disabled-warning">
                        <div class="warning-icon">
                            <i class="fas fa-exclamation-triangle"></i>
                        </div>
                        <h2 class="warning-title">Search temporarily unavailable</h2>
                        <p class="warning-message">
                            We're experiencing a temporary service issue. You can still access and export your previous search history below.
                        </p>
                    </div>
                </div>

                <!-- Search Card -->
                <div class="search-card-container py-3" *ngIf="!isServiceDisabled">
                    <div class="search-card">
                        <h2 class="search-title">
                            <i class="fas fa-car"></i> Search Vehicle
                        </h2>
                        <p class="search-card-subtitle">
                            Each search costs <strong>{{ searchCreditCost || 1 }}</strong>
                            {{ (searchCreditCost || 1) === 1 ? 'credit' : 'credits' }}. If no results are found credits will be refunded.
                        </p>
                        <div class="restricted-alert" appRestrictedAccessWarning>
                            <i class="fas fa-exclamation-circle alert-icon"></i>
                            <span class="alert-text">
                                <span class="alert-restricted">RESTRICTED ACCESS</span>
                                <span class="alert-authorized">Authorized Law Enforcement Use Only</span>
                            </span>
                        </div>
                        <div class="search-input-container">
                            <div class="email-input-group">
                                <input type="text" [(ngModel)]="vehicleNumber" class="email-input" placeholder="Enter Vehicle Number (e.g. MH22AV3122)">
                            </div>
                            <button type="button" (click)="searchVehicle()" class="search-button rounded">Search</button>
                        </div>
                    </div>
                </div>

                <div class="loading-container" *ngIf="searchLoading || loadingRecentResults">
                    <div class="spinner-border" role="status"></div>
                    <p class="loading-text">Fetching results, please wait...</p>
                </div>

                <div class="results-section">

                    <!-- <div class="card"> -->
                    <div class="card-body p-2 p-md-4">
                        <div class="results-topbar">
                            <div class="results-header">
                                <h3 class="results-title">Recent Vehicle Searches</h3>
                                <p class="results-subtitle">Click any vehicle number to reopen the report.</p>
                            </div>

                            <div class="results-controls">
                                <!-- Filter Controls -->
                                <div class="filter-section">
                                    <select class="filter-select" [(ngModel)]="selectedFilterType" (ngModelChange)="onFilterTypeChange()">
                                        <option *ngFor="let filterType of filterTypes" [value]="filterType.value">
                                            {{ filterType.label }}
                                        </option>
                                    </select>
                                    <div class="filter-input-container">
                                        <input *ngIf="selectedFilterType === 'number'" class="filter-input" type="text" placeholder="Search by content" [(ngModel)]="numberFilter">

                                        <input *ngIf="selectedFilterType === 'notes'" class="filter-input" type="text" placeholder="Search by content" [(ngModel)]="notesFilter">

                                        <div class="date-filter-group" *ngIf="selectedFilterType === 'date-added'">
                                            <input class="filter-input date-input" type="date" [(ngModel)]="startDateFilter">
                                            <input class="filter-input date-input" type="date" [(ngModel)]="endDateFilter">
                                        </div>
                                    </div>
                                </div>

                                <!-- Action Buttons -->
                                <div class="action-buttons">
                                    <!-- 
                                <button class="action-btn export-btn" (click)="onExportExcelButtonClick()">
                                    <i class="fas fa-file-excel"></i>
                                    Export Excel
                                </button>
                                <button class="action-btn export-btn" (click)="onExportCsvButtonClick()">
                                    <i class="fas fa-file-csv"></i>
                                    Export CSV
                                </button>
                                <button class="action-btn export-btn" (click)="onExportPdfButtonClick()">
                                    <i class="fas fa-file-pdf"></i>
                                    Export PDF
                                </button>

                                -->
                                    <button class="action-btn delete-btn" (click)="onDeleteButtonClick()">
                                        <i class="fas fa-trash"></i>
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="results-table-container">
                            <table class="results-table">
                                <colgroup>
                                    <col class="col-checkbox">
                                    <col class="col-number">
                                    <col class="col-status">
                                    <col class="col-date">
                                    <col class="col-time">
                                    <col class="col-notes">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th class="checkbox-column">
                                            <input type="checkbox" class="table-checkbox" [checked]="recentResultsSelectAll.isSelected" (change)="onRecentResultsSelectAllClick()">
                                        </th>
                                        <th>Vehicle Number</th>
                                        <th>Status</th>
                                        <th>Date Added</th>
                                        <th>Time</th>
                                        <th>Notes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngIf="!searchLoading && !loadingRecentResults && (!recentResultsPaged?.length || recentResultsCount === 0)" class="no-data-row">
                                        <td colspan="6" class="no-data-cell">No results yet. Search using the input above</td>
                                    </tr>
                                    <tr *ngFor="let recentResultPaged of recentResultsPaged" class="table-row">
                                        <td class="checkbox-column">
                                            <input type="checkbox" class="table-checkbox" [checked]="recentResultPaged.isSelected" (click)="onRecentResultPagedClick($event, recentResultPaged)">
                                        </td>
                                        <td class="number-column" (click)="goToSearchResultPage(recentResultPaged)">
                                            {{ recentResultPaged.vehicle_number }}
                                        </td>
                                        <td class="status-column">
                                            <span class="status-badge" [class.status-completed]="recentResultPaged.done" [class.status-pending]="!recentResultPaged.done">
                                                {{ recentResultPaged.done ? 'Completed' : 'Pending' }}
                                            </span>
                                        </td>
                                        <td class="date-column">
                                            {{ recentResultPaged.created_on | date : 'MMM d, y' }}
                                        </td>
                                        <td class="time-column">
                                            {{ recentResultPaged.created_on | date : 'HH:mm:ss' }}
                                        </td>
                                        <td class="notes-column" [title]="recentResultPaged.notes || ''">{{ truncateToWords(recentResultPaged.notes) || 'Test notes will come here.' }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="pagination-container">
                            <div class="pagination-info">
                                Showing {{ recentResultsPagedStartAndEnd.start }} of {{ recentResultsCount }} result
                            </div>
                            <div class="pagination-controls">
                                <app-paginator [totalItems]="recentResultsCount" [itemsPerPage]="recentResultsPerPage" [currentPage]="recentResultsCurrentPage" (pageChange)="onRecentResultsPageChange($event)">
                                </app-paginator>
                            </div>
                        </div>

                    </div>
                    <!-- </div> -->

                </div>
            </div>
        </div>
    </div>
</div>